import { useSessionUserId } from '../utils/session';
import HomePage from './HomePage';

/**
 * `/` signed in: the person's Home (HomePage) — pinned launchers and records
 * from every collection, recent views, the collections strip.
 *
 * Signed out, `/` is keepr's public landing page (KPR-316), which RootFrame
 * renders in the public shell INSTEAD of the app shell, so this page is never
 * reached without a session. (Until KPR-316 it was the brand hero and the
 * sign-in form; the form is at `/login`.) Should it ever render without one,
 * it renders nothing rather than a hollow Home.
 *
 * The page follows the SESSION (utils/session.js), not a token read once
 * while rendering: a token the API refuses on `/` is forgotten in place by
 * the api client's interceptor (endsSessionInPlace), and Home must hear it
 * go. The session is keyed onto HomePage too, so another account signing in
 * on this tab gets a fresh Home, never a frame of the last one's.
 */
export default function Home() {
	const session = useSessionUserId();

	if (!session) return null;
	return <HomePage key={session} />;
}
